<template>
  <div class="resize-panels" @mouseenter="onHover" @mouseleave="onUnhover">
    <div class="resize-panel resize-panel__left noHideSidebar" @click.prevent="toggle"></div>
    <div class="resize-panel resize-panel__right noHideSidebar" @click.prevent="toggle"></div>
  </div>
</template>

<script>
  export default {
    methods: {
      onHover () {
        this.$store.commit('resizePanelsHovered', true)
      },
      onUnhover () {
        this.$store.commit('resizePanelsHovered', false)
      },
      toggle () {
        this.$store.commit('bodyMaximized')
      }
    },
    beforeDestroy () {
      this.onUnhover()
    }
  }
</script>
<style lang="scss">
  @import '../../assets/sass/grid';

  // REsizer component
  .app__preheader .container{transition: all .4s ease;}
  @media (min-width:1550px) {
    .bodyMaximized{
      .navbar,
      .app__preheader .container{max-width: 95vw;}
      .dashboardLayout__content--wrapper{width: 95vw;}
      .sidebar, .navbar {
        left:2.5vw;
      }
    }
  }
  .resize-panels{
    user-select: none;
    &:hover{
      .resize-panel {
        background-color: rgba(25, 137, 250, 0.03);
        svg{opacity: 1;}
        svg path{fill:rgba(119, 169, 237, 0.5) !important;}
        border-color: rgba(25, 137, 250, 0.5);
      }
    }
  }
  .resize-panel{
    &{
      position: absolute;
      top: 0;
      z-index: 20;
      cursor: pointer;
      transition: all .4s ease;
      svg{
        transition: all .4s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: calc(100% - 50px);
      }
      svg path{transition: all .4s ease;}
      &:hover{
        background-color: rgba(25, 137, 250, 0.03);
        svg{opacity: 1;}
      }
      &.is-minimize{
        width: 80px !important;
        svg{
          transform: rotate(180deg) scale(.5);opacity: 1;
          path{fill:#c3c3c3;}
        }
      }
    }
    &__left{
      right: 100%;
      width: calc(50vw - #{$width-xl} / 2 );
      height: 100%;
      border-right: 1px solid transparent;
      &:hover{
        border-color: rgba(25, 137, 250, 0.5);
      }
      &.is-minimize{
        svg{
          left: calc(50% - 30px);
        }
      }
    }
    &__right{
      left: 100%;
      width: calc(50vw - #{$width-xl} / 2 );
      height: 100%;
      border-left: 1px solid transparent;
      &:hover,&.is-active{
        border-color: rgba(25, 137, 250, 0.5);
      }
      svg{
        transform: rotate(180deg);
        left: 30px;
      }
      &.is-minimize{
        svg{transform: rotate(0deg) scale(.5);}
      }
    }
  }
  @media (min-width:1550px) {
    .bodyMaximized{
      .resize-panel {
        &__left {
          width: 2.5vw;
        }
        &__right {
          width: 2.5vw;
        }
      }
    }
  }
  @media (max-width:1550px) { .resize-panel{display: none;}  .resize-panels-arrows{display: none !important;}  }
</style>